import { render, staticRenderFns } from "./POD-10Report-2023.vue?vue&type=template&id=26462195&scoped=true&"
import script from "./POD-10Report-2023.vue?vue&type=script&lang=js&"
export * from "./POD-10Report-2023.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26462195",
  null
  
)

export default component.exports